import React, { ReactElement } from 'react';
import { Col, Row, Text } from 'idsk-react-components';
import './legislativnyMaterialDetailRow.scss';

interface Props<T> {
  header: string;
  data?: string | number | T[];
  itemAttributeToShow?: keyof T;
  firsColumnSize?: 'one-third' | 'one-quarter';
}

const LegislativnyMaterialDetailRow = (<T, >({
  header,
  data,
  itemAttributeToShow,
  firsColumnSize = 'one-third',
}: Props<T>): ReactElement => {
  const secondColumnSize = firsColumnSize === 'one-third' ? 'two-thirds' : 'three-quarters';

  if (Array.isArray(data)) {
    if (data.length === 1) {
      return (
        <Row className="material-detail-row">
          <Col width={firsColumnSize}>
            <Text type="span" className="information-header">{header}</Text>
          </Col>
          <Col width={secondColumnSize}>
            <Text type="p" className="material-detail-row-text">{data[0][itemAttributeToShow]}</Text>
          </Col>
        </Row>
      );
    }

    if (data.length === 0) {
      return (<></>);
    }

    return (
      <Row className="material-detail-row">
        <Col width={firsColumnSize}>
          <Text type="span" className="information-header">{header}</Text>
        </Col>
        <Col width={secondColumnSize}>
          <Text type="ul">
            {data.map((dataRecord, index) => (
              <li>
                <div className="material-detail-row-list-item">
                  <Text
                    /* eslint-disable-next-line react/no-array-index-key */
                    key={index}
                    className="material-detail-row-text"
                  >{dataRecord[itemAttributeToShow]}
                  </Text>
                </div>
              </li>
            ))}
          </Text>
        </Col>
      </Row>
    );
  }

  return data ? (
    <Row className="material-detail-row">
      <Col width={firsColumnSize}>
        <Text type="span" className="information-header">{header}</Text>
      </Col>
      <Col width={secondColumnSize}>
        <Text type="p" className="material-detail-row-text">{data}</Text>
      </Col>
    </Row>
  ) : <></>;
});

export default LegislativnyMaterialDetailRow;
